import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSidebarData } from 'app-context/sidebar/SidebarDataProvider';

const useAuth = () => {
  return !!localStorage.getItem('token');
};

const PublicRoute = () => {
  const auth = useAuth();
  const { sidebarData } = useSidebarData();

  const firstRoute =
    sidebarData?.data && sidebarData.data.length > 0
      ? sidebarData.data[0].routeTo
      : '/';

  return auth ? <Navigate to={firstRoute} replace /> : <Outlet />;
};

export default PublicRoute;
